module.exports = __webpack_public_path__ + "img/bg-accident-item-6.a5b203bf.png";